
import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appGalaxyRipple]',
  standalone: true,
})
export class GalaxyRippleDirective {
  @Input() rippleColor = 'rgba(255, 255, 255, 0.7)';

  constructor(private readonly elementRef: ElementRef<HTMLElement>) {}

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    const hostElement = this.elementRef.nativeElement;

    // Crear el contenedor del ripple
    const ripple = document.createElement('span');
    const hostRect = hostElement.getBoundingClientRect();
    
    const size = Math.max(hostRect.width, hostRect.height);
    const x = event.clientX - hostRect.left - size / 2;
    const y = event.clientY - hostRect.top - size / 2;

    ripple.style.width = ripple.style.height = `${size}px`;
    ripple.style.left = `${x}px`;
    ripple.style.top = `${y}px`;
    ripple.style.position = 'absolute';
    ripple.style.borderRadius = '50%';
    ripple.style.backgroundColor = this.rippleColor;
    ripple.style.transform = 'scale(0)';
    ripple.style.animation = 'ripple-animation 600ms linear';
    ripple.style.pointerEvents = 'none';

    hostElement.appendChild(ripple);

    // Limpiar el ripple del DOM después de la animación
    setTimeout(() => {
      ripple.remove();
    }, 600);
  }
}
